<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <page-header />
    </parallax>
    <div id="main-panel" class="main main-raised" ref="page">
      <div class="cd-section section section-basic">
        <div class="md-layout" v-if="loaded">
          <div class="md-layout-item md-size-90 mx-auto text-center" style="margin-bottom:0px">
            <h2
              class="title text-primary black"
              style="margin-top:0px"
            >{{$t('Recreational events')}}</h2>
          </div>
          <div
            class="md-layout md-layout-item md-size-75 md-medium-size-90 md-xsmall-size-95 mx-auto md-gutter"
            v-if="items.length"
          >
            <item
              v-for="item in items"
              :key="item.id"
              :item="item"
              @showDetails="onShowDetails(item)"
              @onSignUp="onSignUp(item)"
              @onSignOut="onSignOut(item)"
              class="md-layout md-layout-item md-size-50 md-small-size-75 md-xsmall-size-95 mx-auto"
            />
          </div>
          <no-data
            class="md-layout-item md-size-75 md-medium-size-90 md-xsmall-size-95 mx-auto text-center"
            v-else
          />
        </div>
      </div>
    </div>

    <div class="modal modal-bg" :class="{ show: selectedItem }">
      <modal v-if="selectedItem" @close="selectedItem = null">
        <template slot="header">
          <h3 class="title text-center">{{selectedItem.description.title}}</h3>
          <md-button
            class="md-simple md-close md-just-icon md-round modal-default-button"
            @click="selectedItem = null"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>

        <template slot="body">
          <div v-html="selectedItem.description.content" />
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import { mapGetters, mapActions } from "vuex";
import axios from "@/util/axios";
import { Modal } from "@/components";
import Item from "./components/PartyEvents/ListItem.vue";
import PageHeader from "./layout/PageHeader";
import NoData from "@/pages/authenticated/NoData";

export default {
  components: { Item, Modal, PageHeader, NoData },
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",
  computed: {
    ...mapGetters({
      language: "language/current",
      conference: "conference/current"
    })
  },
  data() {
    return {
      loaded: false,
      selectedItem: null,
      items: [],
      image: require("@/assets/img/conference/landing-bg.jpg") // header img
    };
  },
  methods: {
    async loadData() {
      let loader = this.$loading.show({ container: this.$refs.page });

      try {
        this.items = (
          await axios.get("public/conferences/conference/party-events", {
            params: {
              year: this.conference.year,
              type: this.conference.type,
              language: this.language.code
            }
          })
        ).data;
      } finally {
        loader.hide();
        this.loaded = true;
      }
    },
    async onShowDetails(item) {
      let result = (
        await axios.get("public/conferences/conference/party-events/details", {
          params: {
            id: item.id,
            language: this.language.code
          }
        })
      ).data;

      item.description.content = result;
      this.selectedItem = item;
    },
    async onSignUp(item) {
      let loader = this.$loading.show({ container: this.$refs.page });
      var success = false;
      try {
        success = (
          await axios.post(
            "public/conferences/conference/party-events/signup",
            {
              conferenceYear: this.conference.year,
              conferenceType: this.conference.type,
              language: this.language.code,
              id: item.id
            }
          )
        ).data;
      } finally {
        loader.hide();

        let text = success
          ? this.$t("Signed up for recreational event")
          : this.$t("Error occured");

        this.$swal({
          icon: success ? "success" : "error",
          text: text
        });

        await this.loadData();
      }
    },
    async onSignOut(item) {
      let loader = this.$loading.show({ container: this.$refs.page });
      var success = false;
      try {
        success = (
          await axios.post(
            "public/conferences/conference/party-events/signout",
            {
              conferenceYear: this.conference.year,
              conferenceType: this.conference.type,
              language: this.language.code,
              id: item.id
            }
          )
        ).data;
      } finally {
        loader.hide();

        let text = success
          ? this.$t("Signed out from recreational event")
          : this.$t("Error occured");

        this.$swal({
          icon: success ? "success" : "error",
          text: text
        });

        await this.loadData();
      }
    }
  },
  async mounted() {
    await this.loadData();
  },
  watch: {
    async language() {
      this.loaded = false;
      this.model = { description: {}, panels: [] };
      await this.loadData();
    }
  }
};
</script>


<style lang="scss" scoped>
h1.info-title {
  font-size: 5rem;
}
.info-title {
  color: white !important;
}

.info-title > hr {
  color: white;
}

.page-header .container {
  max-width: 70% !important;
}
</style>
